module.exports = __webpack_public_path__ + "static/media/odologo.bc241c54.jpg";